import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "absolute top-4.5 right-4 z-30" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("button", null, [
  /*#__PURE__*/_createElementVNode("svg", { class: "icon w-8 h-8 text-creation-on-background transition text-opacity-creation-medium hover:text-opacity-creation-full stroke-[1.5]" }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/icons-v3.svg#replay" })
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}